export function buildMetadata(extra?: Record<string, unknown>): Record<string, unknown> {
  const nav = typeof navigator !== 'undefined' ? navigator : undefined;
  const win = typeof window !== 'undefined' ? window : undefined;
  const scr = typeof screen !== 'undefined' ? screen : undefined;

  return {
    timestamp: new Date().toISOString(),
    userAgent: nav?.userAgent,
    language: nav?.language,
    platform: nav?.platform,
    online: nav?.onLine,
    viewport: win ? { width: win.innerWidth, height: win.innerHeight } : undefined,
    screen: scr ? { width: scr.width, height: scr.height } : undefined,
    pathname: win?.location?.pathname,
    ...extra
  };
}
